module.exports = __webpack_public_path__ + "img/avatar-78.e8261cee.png";